/* eslint-disable */
import i18n from "../i18n";

export function getArabicStatusByIdZimou(statusNameFr) {
  const statuses = {
    "EN PREPARATION": i18n.t("ship.in_preparation"),
    "PRÊT À EXPÉDIER": i18n.t("ship.ready_to_ship"),
    "EXPEDIE": i18n.t("shipmentStatus.sent"),
    "VERS WILAYA ( SAC )": i18n.t("shipmentStatus.toStateBag"),
    "CENTRE ( HUB )": i18n.t("shipmentStatus.atHub"),
    "TRANSFERT (SAC)": i18n.t("shipmentStatus.transferBag"),
    "SORTIE EN LIVRAISON": i18n.t("shipmentStatus.outForDelivery"),
    "LIVRÉ": i18n.t("ship.delivered"),
    "ÉCHEC DE LIVRAISON": i18n.t("shipmentStatus.deliveryFailed"),
    "ALERT": i18n.t("warning"),
    "REPORTER (Date)": i18n.t("shipmentStatus.postponedDate"),
    "EN ATTENTE": i18n.t("shipmentStatus.waiting"),
    "TENTATIVE ÉCHOUÉE 1": i18n.t("shipmentStatus.failedAttempt1"),
    "TENTATIVE ÉCHOUÉE 2": i18n.t("shipmentStatus.failedAttempt2"),
    "TENTATIVE ÉCHOUÉE 3": i18n.t("shipmentStatus.failedAttempt3"),
    "RETOUR VERS CENTRE": i18n.t("shipmentStatus.returningToHub"),
    "RETOURNEE AU CENTRE": i18n.t("shipmentStatus.returnedToHub"),
    "RETOUR A RETIRER": i18n.t("shipmentStatus.returnAwaitingPickup"),
    "RETOUR VERS VENDEUR (SAC)": i18n.t("shipmentStatus.returnToSellerBag"),
    "RETOURNEE AU VENDEUR (SAC)": i18n.t("shipmentStatus.returnedToSellerBag"),
    "SOCIETE PARTENAIRE": i18n.t("shipmentStatus.partnerCompany"),
    "REFUSÉ": i18n.t("services.foorCall.status.rejected"),
    "PICKUP": i18n.t("shipmentStatus.pickup"),
    "En Dispatche": i18n.t("shipmentStatus.dispatching"),
    "Dispatché": i18n.t("shipmentStatus.dispatched"),
    "WAREHOUSE EN PREPARATION": i18n.t("shipmentStatus.warehousePreparing"),
    "WAREHOUSE HORS STOCK": i18n.t("shipmentStatus.warehouseOutOfStock"),
    "WAREHOUSE PRET": i18n.t("shipmentStatus.warehouseReady"),
    "WAREHOUSE RETOURNÉE": i18n.t("shipmentStatus.warehouseReturned"),
    "WAREHOUSE DEMANDE ANNULATION": i18n.t("shipmentStatus.warehouseCancelRequested"),
    "WAREHOUSE ANNULÉE": i18n.t("shipmentStatus.warehouseCancelled"),
    "WAREHOUSE RETOURNÉE ENDOMAGÉ": i18n.t("shipmentStatus.warehouseReturnedDamaged"),
    "PAS ENCORE RAMASSÉ": i18n.t("shipmentStatus.notCollectedYet"),
    "DROPSHIP EN PREPARATION": i18n.t("shipmentStatus.dropshipPreparing"),
    "DROPSHIP PRET": i18n.t("shipmentStatus.dropshipReady"),
    "ECHANGE A RETIRER": i18n.t("shipmentStatus.exchangeAwaitingPickup"),
    "DROPSHIPS RETOURNEÉ": i18n.t("shipmentStatus.dropshipReturned"),
    "DROPSHIPS RETOURNEÉ ENDOMMAGÉ": i18n.t("shipmentStatus.dropshipReturnedDamaged"),
    "ECHANGE COLLECTÉ": i18n.t("shipmentStatus.exchangeCollected"),
    "AU CENTRE": i18n.t("ship.at_hub"),
    "DROPSHIPS DEMANDE ANNULATION": i18n.t("shipmentStatus.dropshipCancelRequested"),
    "DROPSHIPS ANNULÉE": i18n.t("shipmentStatus.dropshipCancelled"),
    "FRET EN PREPARATION": i18n.t("shipmentStatus.freightPreparing"),
    "FRET PRET": i18n.t("shipmentStatus.freightReady"),
    "FRET DEMANDE ANNULATION": i18n.t("shipmentStatus.freightCancelRequested"),
    "FRET ANNULÉE": i18n.t("shipmentStatus.freightCancelled"),
    "Bloqué": i18n.t("shipmentStatus.blocked"),
    "En localisation": i18n.t("shipmentStatus.locating"),
    "Prêt pour livreur": i18n.t("shipmentStatus.readyForDelivery")
  };

  return statuses[statusNameFr] || i18n.t("shipmentStatus.unknown");
}


export function traduireStatutMaystro(code) {
  switch (code) {
    case 4:
      return i18n.t("shipmentStatus.created");
    case 5:
      return i18n.t("shipmentStatus.pickupRequested");
    case 6:
      return i18n.t("ui.processing");
    case 8:
      return i18n.t("shipmentStatus.awaitingTransfer");
    case 9:
      return i18n.t("shipmentStatus.onWayToDispatch");
    case 10:
      return i18n.t("shipmentStatus.onWayToReturn");
    case 11:
      return i18n.t("stats.pending");
    case 12:
      return i18n.t("shipmentStatus.outOfStock");
    case 15:
      return i18n.t("ship.ready_to_ship");
    case 22:
      return i18n.t("shipmentStatus.assigned");
    case 31:
      return i18n.t("shipmentStatus.sent");
    case 32:
      return i18n.t("shipmentStatus.alerted");
    case 41:
      return i18n.t("foorcall_stats.delivery.delivered");
    case 42:
      return i18n.t("shipmentStatus.postponed");
    case 50:
      return i18n.t("Products.Table.confirmers.cancelledPrice");
    case 51:
      return i18n.t("shipmentStatus.readyForReturn");
    case 52:
      return i18n.t("shipmentStatus.collectedFromStore");
    case 53:
      return i18n.t("shipmentStatus.notReceived");
    default:
      return i18n.t("shipmentStatus.unknown");
  }
}

export function translateCompanyDeliveryStatusEcotrack(status) {
  const translations = {
    "prete_a_expedier": i18n.t("ship.ready_to_ship"),
    "en_ramassage": i18n.t("shipmentStatus.collectionStage"),
    "en_preparation_stock": i18n.t("shipmentStatus.preparingFromStock"),
    "vers_hub": i18n.t("shipmentStatus.toProcessingHub"),
    "en_hub": i18n.t("shipmentStatus.atProcessingHub"),
    "vers_wilaya": i18n.t("shipmentStatus.toState"),
    "en_preparation": i18n.t("shipmentStatus.beingPrepared"),
    "en_livraison": i18n.t("shipmentStatus.deliveryStage"),
    "suspendu": i18n.t("ship.on_hold"),
    "livre_non_encaisse": i18n.t("shipmentStatus.deliveredNotCollected"),
    "encaisse_non_paye": i18n.t("shipmentStatus.collectedNotPaid"),
    "paiements_prets": i18n.t("shipmentStatus.paymentsReady"),
    "paye_et_archive": i18n.t("shipmentStatus.paidArchived"),
    "retour_chez_livreur": i18n.t("shipmentStatus.returnWithCourier"),
    "retour_transit_entrepot": i18n.t("shipmentStatus.returnToWarehouse"),
    "retour_en_traitement": i18n.t("shipmentStatus.returnProcessing"),
    "retour_reçu": i18n.t("shipmentStatus.returnReceived"),
    "retour_archive": i18n.t("shipmentStatus.returnArchived"),
    "annule": i18n.t("stats.cancelled"),
    "all": i18n.t("ship.all")
  };

  return translations[status] || i18n.t("shipmentStatus.unknown");
}

export function translateLastStatusToArabicYalidine(status) {
  switch (status.toLowerCase()) {
    case "not-ready":
      return i18n.t("shipmentStatus.notReady");
    case "ready":
      return i18n.t("ui.ready");
    case "receivable":
      return i18n.t("shipmentStatus.readyForPickup");
    case "payed":
      return i18n.t("orders.paid");
    case "Pas encore expédié":
      return i18n.t("shipmentStatus.notDispatchedYet");
    case "A vérifier":
      return i18n.t("shipmentStatus.verifying");
    case "En préparation":
      return i18n.t("shipmentStatus.beingPrepared");
    case "Pas encore ramassé":
      return i18n.t("shipmentStatus.notCollected");
    case "Prêt à expédier":
      return i18n.t("ship.ready_to_ship");
    case "Ramassé":
      return i18n.t("shipmentStatus.collected");
    case "Bloqué":
      return i18n.t("shipmentStatus.blocked");
    case "Débloqué":
      return i18n.t("shipmentStatus.unblocked");
    case "Transfert":
      return i18n.t("shipmentStatus.transfer");
    case "Expédié":
      return i18n.t("shipmentStatus.sent");
    case "Centre":
      return i18n.t("ui.district");
    case "En localisation":
      return i18n.t("shipmentStatus.locatingStage");
    case "Vers Wilaya":
      return i18n.t("shipmentStatus.toState");
    case "Reçu à Wilaya":
      return i18n.t("shipmentStatus.receivedInState");
    case "En attente du client":
      return i18n.t("shipmentStatus.awaitingCustomer");
    case "Prêt pour livreur":
      return i18n.t("shipmentStatus.readyForCourier");
    case "Sorti en livraison":
      return i18n.t("shipmentStatus.outForDelivery");
    case "En attente":
      return i18n.t("shipmentStatus.waiting");
    case "En alerte":
      return i18n.t("shipmentStatus.alert");
    case "Tentative échouée":
      return i18n.t("shipmentStatus.failedAttempt");
    case "Livré":
      return i18n.t("ship.delivered");
    case "Echèc livraison":
      return i18n.t("shipmentStatus.deliveryFailed");
    case "Retour vers centre":
      return i18n.t("shipmentStatus.returningToCenter");
    case "Retourné au centre":
      return i18n.t("shipmentStatus.returnedToCenter");
    case "Retour transfert":
      return i18n.t("shipmentStatus.returnInTransit");
    case "Retour groupé":
      return i18n.t("shipmentStatus.returnGrouped");
    case "Retour à retirer":
      return i18n.t("shipmentStatus.returnForPickup");
    case "Retour vers vendeur":
      return i18n.t("shipmentStatus.returningToSeller");
    case "Retourné au vendeur":
      return i18n.t("shipmentStatus.returnedToSeller");
    case "Echange échoué":
      return i18n.t("shipmentStatus.exchangeFailed");

    default:
      return i18n.t("shipmentStatus.unknown");
  }
}
